<template>
  <div class="row definition-select-wrapper">
    <b-col cols="12" md="6" class="definition-selector">
      <vue-autosuggest
        :suggestions="filteredSuggestions"
        v-model="query"
        :input-props="{
          type: 'search',
          class: 'input form-control select definition_input',
          id: 'definition_input',
          placeholder: 'Kezdje el begépelni a fogalmat majd válasszon a listából',
          disabled
        }"
        @selected="selectHandler"
        ref="autosuggestRef"
      >
        <template slot="before-input">
          <label for="definition_input">Kapcsolódó fogalmak</label>
        </template>
        <template slot-scope="{ suggestion }">
          <span class="my-suggestion-item"> {{ suggestion.item.name }} </span>
        </template>
      </vue-autosuggest>
    </b-col>
    <b-col cols="12" md="6" class="selected-definitions-grp mt-4 mt-md-0">
      <div
        v-for="definition in selected"
        :key="definition.slug"
        variant="outline-primary"
        :id="definition.slug"
        class="selected-definition"
      >
        {{ definition.name }}

        <b-button class="remove-selected-definition-btn" variant="primary" @click="removeDefinition"
          ><font-awesome-icon icon="fa-solid fa-xmark" class="icon" />
        </b-button>
      </div>
    </b-col>
  </div>
</template>

<script>
import { VueAutosuggest } from 'vue-autosuggest'
import { getRelatedDefinitions } from '../../../api/knowledgebase'
export default {
  data: function() {
    return {
      suggestions: [],
      query: '',
      selected: []
    }
  },
  props: {
    disabled: { type: Boolean },
    state: { type: Array }
  },
  components: {
    VueAutosuggest
  },
  computed: {
    filteredSuggestions() {
      return [
        {
          data: this.suggestions.filter(item => {
            return (
              item.name.toLowerCase().indexOf(this.query.toLowerCase()) > -1 ||
              item.slug.toLowerCase().indexOf(this.query.toLowerCase()) > -1
            )
          })
        }
      ]
    },
    selectedSlugs() {
      return [{ data: this.selected.map(e => e.slug) }]
    }
  },
  methods: {
    selectHandler(item) {
      if (item) {
        this.selected.push(item.item)
        let idx = this.suggestions.findIndex(e => e.slug === item.item.slug)
        this.suggestions.splice(idx, 1)
        this.query = ''
        this.$refs.autosuggestRef.internalValue = ''
        this.$emit('new-seleted-definitions', this.selectedSlugs)
      }
    },
    removeDefinition(evt) {
      let elem = evt.srcElement.closest('.selected-definition')
      let idx = this.selected.findIndex(e => e.slug === elem.id)
      this.suggestions.push(this.selected[idx])
      this.selected.splice(idx, 1)
      this.$emit('new-seleted-definitions', this.selectedSlugs)
    }
  },
  watch: {
    disabled() {
      if (this.disabled) {
        this.$refs.autosuggestRef.internalValue = ''
      }
    }
  },
  async mounted() {
    this.suggestions = await getRelatedDefinitions()
    // NOTE: this state is not two-way, new definitions are emitted from the component
    if (this.state) {
      for (let s of this.state) {
        let idx = this.suggestions.findIndex(e => e.slug === s)
        this.selected.push(this.suggestions[idx])
        this.suggestions.splice(idx, 1)
      }
    }
  }
}
</script>

<style>
.remove-selected-definition-btn {
  border-radius: 2px;
  margin: 5px;
  padding: 2px;
  line-height: 1;
  height: auto;
}

.definition-selector {
  display: inline-block;
}

.selected-definitions-grp {
  display: inline-block;
}

.selected-definition {
  display: flex;
  font-size: 0.8rem;
  background-color: #fff;
  border: 1px solid #00903c;
  border-radius: 4px;
  color: #00903c;
  float: left;
  padding: 10px;
  margin: 5px;
}

.autosuggest__results {
  font-size: 1rem;
}

.autosuggest__results li {
  padding: 10px;
}
#autosuggest__input {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border: 2px solid #b2bec3;
  max-height: 50px;
  border-radius: 4px;
  font-size: 16px;
  color: black !important;
}

@media all and (max-width: 993px) {
  .autosuggest__results-item {
    font-size: 12px;
  }
}

.definiton_input {
  display: block;
  border: 2px solid #b2bec3 !important;
  width: 60% !important;
}
</style>
